import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 185px;
`;
